// import React from 'react'

// const Footer = () => {
//   return (
//     <>

//       <footer id="footer" className="footer   ">
//         <div className="copyright">
//           &copy; Copyright <strong><span>NiceAdmin</span></strong>. All Rights Reserved
//         </div>
//         <div className="credits">
//           Designed by <a href="https://bootstrapmade.com/">BootstrapMade</a>
//         </div>
//       </footer>
//     </>
//   ) 
// }

// export default Footer


import React from 'react';
// import './Footer.css'; // Import your custom CSS file for Footer styles

const Footer = () => {
  return (
    <footer id="footer" className="footer">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-6">
            <div className="footer-content">
              <h3>Your Sales Admin</h3>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla nec purus feugiat,
                quam tincidunt laoreet ipsum.
              </p>
            </div>
          </div>
          <div className="col-lg-3 col-md-3">
            <div className="footer-links">
              <h4>Useful Links</h4>
              <ul>
                <li><a href="#">Home</a></li>
                <li><a href="#">Products</a></li>
                <li><a href="#">Contact Us</a></li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3 col-md-3">
            <div className="footer-contact">
              <h4>Contact Us</h4>
              <p>
                Email: info@yoursalesadmin.com <br />
                Phone: +123 456 7890
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <p className="text-center">
                &copy; {new Date().getFullYear()} Your Sales Admin. All Rights Reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
